var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #99cfe2;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #121628;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2-2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70,140C31.53,140,0,108.47,0,70S31.53,0,70,0s70,31.53,70,70-31.53,70-70,70ZM70,3.78C33.42,3.78,4.41,33.42,4.41,69.37s29.64,65.59,65.59,65.59,65.59-29.64,65.59-65.59S105.95,3.78,70,3.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.22,86.19c-.11,0-.21,0-.31,0h-.17s-28.21,0-28.21,0v-28.4c0-.1-.01-.2-.01-.29s0-.2,0-.29v-1.7h.07c1.02-15.06,13.42-26.72,28.63-26.72s28.71,12.88,28.71,28.71-12.88,28.71-28.71,28.71ZM28.52,84.17h26.7c14.73.01,26.71-11.97,26.71-26.7s-11.98-26.71-26.71-26.71-26.18,11.31-26.69,25.75l-.02.96v.46s.01,26.24.01,26.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M94.6,100.65c-11.09,0-20.74-7.88-22.96-18.73l-.07-.33.29-.19c7.85-5.04,12.54-13.6,12.54-22.91,0-.59-.03-1.22-.08-1.97l-.02-.34.31-.15c3.14-1.48,6.5-2.24,10-2.24,12.52,0,22.7,9.67,23.38,22.11h.02l.02,1.32v.39s0,23.02,0,23.02h-23.42ZM72.7,82.05c2.24,10.22,11.4,17.59,21.91,17.59h.38s22.04,0,22.04,0v-23.22c-.44-12.13-10.28-21.62-22.42-21.62-3.23,0-6.34.67-9.26,2,.04.63.06,1.18.06,1.7,0,9.53-4.74,18.31-12.7,23.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.08,53.31c.09-4.53,3.04-7.83,7.71-7.83,5.96,0,7.9,3.71,7.9,6.12,0,6.06-5.23,5.23-5.77,9.07v1.2h-4.28v-1.43c.44-5.49,5.17-4.98,5.07-8.4,0-1.93-1.01-2.85-2.7-2.85-2.28,0-3.27,1.87-3.27,4.12h-4.66ZM50.19,63.78h4.98v4.88h-4.98v-4.88Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChats);
export default __webpack_public_path__ + "static/media/chats.742e39a0b5d10af8eb90b40f0bb6f49a.svg";
export { ForwardRef as ReactComponent };